import {
  Avatar,
  Button,
  Card,
  CardHeader,
  Fab,
  Grid,
  Hidden,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
} from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Add, MoreVert } from "@material-ui/icons";
import Skeleton from "@material-ui/lab/Skeleton";
import React from "react";
import BaseLayout from "../../components/BaseLayout/BaseLayout";
import { confirm } from "../../components/ConfirmationDialog/ConfirmationDialog";
import InputSearch from "../../components/InputSearch/InputSearch";
import { AntTab, AntTabs } from "../../components/TabPanel/TabPanel";
import usersStore from "../../Store/UsersStore";
import { changePasswordForm } from "./containers/ChangePassword";
import { submitFormTenant } from "./containers/FormTenant";
import "./Users.css";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      width: "100%",
    },
    button: {
      margin: 0,
      maxHeight: 30,
      padding: 1,
    },
    paper: {
      padding: 8,
      width: 290,
    },
    demo1: {
      backgroundColor: theme.palette.background.paper,
      marginBottom: 10,
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(14),
      color: "#FFFFFF",
      textAlign: "center",
      backgroundColor: "#BEBEBE",
      borderRadius: "4px",
    },
    control: {
      padding: theme.spacing(2),
    },
    room: {
      fontSize: "18px",
      fontWeight: 600,
    },
    fab: {
      position: "fixed",
      bottom: theme.spacing(2),
      right: theme.spacing(2),
    },
    card: {
      margin: 5,
      width: "300px",
    },
  })
);

function UserListTenant(props) {
  const user = JSON.parse(localStorage.getItem("user"));
  const {
    dataUsersTenant,
    permissionEditUsersTenant,
    permissionDeleteUsersTenant,
  } = props;
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <React.Fragment>
      <Card className={classes.card}>
        <CardHeader
          avatar={
            <Avatar aria-label="recipe">
              {dataUsersTenant.name.trim().split(" ")[0].charAt(0)}
            </Avatar>
          }
          action={
            <React.Fragment>
              <IconButton aria-label="settings" onClick={handleClick}>
                <MoreVert />
              </IconButton>
              <Menu
                id="long-menu"
                elevation={0}
                anchorEl={anchorEl}
                getContentAnchorEl={null}
                keepMounted
                open={open}
                onClose={handleClose}
              >
                {permissionEditUsersTenant && (
                  <div>
                    <MenuItem
                      onClick={() => props.doChangePassword(dataUsersTenant)}
                    >
                      Change Password
                    </MenuItem>
                    <MenuItem onClick={() => props.doEdit(dataUsersTenant)}>
                      Edit
                    </MenuItem>
                  </div>
                )}

                {permissionDeleteUsersTenant &&
                  user?.id !== dataUsersTenant?.id && (
                    <MenuItem onClick={() => props.doDelete(dataUsersTenant)}>
                      Delete
                    </MenuItem>
                  )}
              </Menu>
            </React.Fragment>
          }
          title={dataUsersTenant.name}
          subheader={dataUsersTenant.role.name}
        />
      </Card>
    </React.Fragment>
  );
}

function UsersTenant(props) {
  const classes = useStyles();
  const [componentWillmount, setComponentWillMount] = React.useState(false);
  const [search, setSearch] = React.useState("");
  const [tab] = React.useState(0);
  const [usersState, usersActions] = usersStore();

  let perPage = 10;

  const handleGetUserList = (refresh) => {
    var query = {
      num: perPage.toString(),
      cursor: refresh ? "" : usersState.header["x-cursor"],
      position: "",
      keyword: search,
      type: "tenant",
    };
    usersActions.getList(query, refresh);
  };

  const handleChangePassword = (value) => {
    changePasswordForm("Change Password", value).then(
      (onProcess) => {},
      (onCancel) => {
        setComponentWillMount(!componentWillmount);
      }
    );
  };

  const handleActions = (value) => {
    if (value) {
      submitFormTenant("Update User Tenant", value).then(
        (onProcess) => {},
        (onCancel) => {
          setComponentWillMount(!componentWillmount);
        }
      );
    } else {
      submitFormTenant("Create User Tenant", null).then(
        (onProcess) => {},
        (onCancel) => {
          setComponentWillMount(!componentWillmount);
        }
      );
    }
  };

  const handleDelete = (value) => {
    confirm("Delete", "Are you sure to Delete ?").then(async (onProcess) => {
      await usersActions.deleted(value);
      setComponentWillMount(!componentWillmount);
    });
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      const refresh = true;
      handleGetUserList(refresh);
    }, 500);

    return () => clearTimeout(timeout);
  }, [componentWillmount, search]);

  return (
    <BaseLayout>
      <Grid container className={classes.root}>
        <Grid container style={{ padding: 5, marginBottom: 10 }}>
          <Grid
            container
            item
            xs={10}
            direction="row"
            alignItems="flex-end"
            justify="flex-start"
          >
            <InputSearch
              value={search}
              onChange={(e) => {
                handleSearch(e);
              }}
              placeholder="Search Staff"
            />
          </Grid>
          <Grid container item xs={2} justify="flex-end" alignItems="flex-end">
            <Hidden xsDown implementation="css">
              {props.params.create && (
                <Tooltip
                  title="add staff"
                  aria-label="add"
                  arrow
                  placement="bottom"
                >
                  <Fab
                    onClick={() => handleActions(null)}
                    color="secondary"
                    variant="extended"
                    aria-label="add"
                    style={{ marginRight: "10px" }}
                  >
                    <Add /> Add{" "}
                  </Fab>
                </Tooltip>
              )}
            </Hidden>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <div className={classes.demo1}>
            <Grid container>
              <Grid
                container
                item
                xs
                direction="row"
                alignItems="flex-end"
                justify="flex-start"
              >
                <AntTabs
                  style={{ marginTop: "10px" }}
                  value={tab}
                  aria-label="ant example"
                >
                  <AntTab label="User List" />
                </AntTabs>
              </Grid>
            </Grid>
          </div>

          <Grid item xs={12} container justify="center">
            {usersState.data.length > 0 &&
              usersState.data.map((value, key) => {
                return (
                  <UserListTenant
                    key={key}
                    dataUsersTenant={value}
                    permissionEditUsersTenant={props.params.update}
                    doChangePassword={() => {
                      handleChangePassword(value);
                    }}
                    doEdit={() => {
                      handleActions(value);
                    }}
                    permissionDeleteUsersTenant={props.params.delete}
                    doDelete={() => {
                      handleDelete(value);
                    }}
                  />
                );
              })}

            {usersState.isLoading &&
              Array.from(new Array(perPage)).map((value, key) => {
                return (
                  <Card className={classes.card} key={key}>
                    <CardHeader
                      avatar={
                        <Skeleton variant="circle" width="40px" height="40px" />
                      }
                      action={
                        <IconButton aria-label="settings">
                          <MoreVert />
                        </IconButton>
                      }
                      title={<Skeleton width="20%" height="10px" />}
                      subheader={<Skeleton width="5%" height="10px" />}
                    />
                  </Card>
                );
              })}
          </Grid>
          {!usersState.isLoading && usersState.data.length === 0 && (
            <Grid item xs={12}>
              <div className={classes.demo1}>
                <Grid
                  item
                  xs
                  container
                  justify="center"
                  style={{ margin: 10, padding: 12 }}
                >
                  <span>No Data</span>
                </Grid>
              </div>
            </Grid>
          )}
          {usersState.data.length >= perPage && (
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
              style={{ padding: "10px" }}
            >
              {usersState.lastPage ? (
                <h2>~</h2>
              ) : (
                <Button
                  onClick={() => handleGetUserList()}
                  size="small"
                  color="secondary"
                  variant="contained"
                  disabled={usersState.isLoading}
                >
                  {usersState.isLoading ? "Please Wait" : "Load More"}
                </Button>
              )}
            </Grid>
          )}
          <Hidden smUp implementation="css">
            {props.params.create && (
              <Tooltip
                title="add reservation"
                aria-label="add"
                arrow
                placement="left"
              >
                <Fab
                  aria-label="Add"
                  classes={{ root: "FabMobile" }}
                  className={classes.fab}
                  color="primary"
                  onClick={() => handleActions(null)}
                >
                  <Add />
                </Fab>
              </Tooltip>
            )}
          </Hidden>
        </Grid>
      </Grid>
    </BaseLayout>
  );
}

export default UsersTenant;
